import { useQuery } from "react-query";
import { publicRequest } from "utils";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import { useMeta } from "hooks";
export const useLabAnalysisInfo = (id: number) => {
  const { language } = useSelector((state: RootState) => state.global); // ✅ Get locale
  const { setMetaTags } = useMeta();
  const { data, isLoading, isError } = useQuery(
    ["labAnalysis", id, language], // Unique cache key
    () =>
      publicRequest({
        url: `/api/lab_analysis/${id}/${language}`,
        method: "get",
      }),
    {
      enabled: !!id,
      onSuccess: (res) => {
        console.log(res?.data);
        setMetaTags(res?.data?.meta);
      } // ✅ Fetch only if ID is provided
    }
  );

  return {
    analysis: data?.data,
    isLoading,
    isError,
  };
};
